
import TourReportResourcesApi from './src/TourReportResources'
import SendSmsApi from './src/SendSmsApi'

let apis = {
   TourReportResourcesApi,
   SendSmsApi
};

export default apis;
